export default __webpack_public_path__ + "static/media/twitter.03d2ff7d.png";